import { tns } from 'tiny-slider/src/tiny-slider.module';
import _ from 'lodash';

export default {
  init() {
    // Our partners Carousel
    tns({
      container: '.instaSlide',
      controlsContainer: '.controls',
      navContainer: '.tns-nav',
      slideBy: 'page',
      autoplay: false,
      items: 1,
      autoHeight: false,
    });

    // Sticky CTA
    $(window).on('scroll', _.throttle(() => {
      if (window.scrollY > 444) {
        $('.sticky-cta').fadeIn();
      } else {
        $('.sticky-cta').hide();
      }
    }, 100));
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/vehicle-history-reports.js